import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import APP from '@/utils/base'
import { getToken } from '@/utils/auth'

/* eslint-disable */
// 创建 axios 实例
let _baseUrl = APP.isTest ? APP.HOST.TEST.ADMIN_URL_MONITOR : APP.HOST.OFFICIAL.ADMIN_URL_MONITOR
const fnService = axios.create({
  baseURL: _baseUrl, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000, // request timeout
})

// request 拦截器
fnService.interceptors.request.use(
  config => {
    config.headers['Content-type'] = 'application/json'
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response 拦截器
fnService.interceptors.response.use(
  /**
   * If you want to get information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code.
   */
  response => {
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 1) {
      Message({
        message: res.data || 'error',
        type: 'error',
        duration: 2 * 1000
      })

      //    301001 签名不正确
      //    301002 签名在某个时间段才能用
			//    301003 token过期
			//    301004 其他错误
			//    301006 登录过期
      if (res.code === 301001 || res.code === 301002 || res.code === 301003 || res.code === 301004 || res.code === 301006) {
        Message.error('授权失败，请重新登录')
        setTimeout(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        }, 1000)
      }
      return Promise.reject(res.message || 'error')
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)
export default fnService



// WEBPACK FOOTER //
// ./src/utils/monitor.js